export { navigationConfig } from './navigation'
export { getAllSettingsPaths, settingsNavigation } from './settingsNavigation'
